// src/pages/PurchaseVoucher/components/PurchaseOrderCorporateVoucher.jsx
import React, { useEffect, useState } from "react";
import { Card, Typography } from "antd";
import { purchaseOrderRecordnWithDetailsApi } from "../../../../../apiservice/purchase";

const { Title, Text } = Typography;

const PurchaseOrderCorporateVoucher = ({ pur_o_id, institution, authInfo, printMode = false }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!pur_o_id) return;
    // Fixed: was purchaseRecordnWithDetailsApi (Purchase BILL endpoint) —
    // queried the wrong table entirely, so this component was blank for any
    // PO not yet converted to a Bill. Now the same Purchase ORDER endpoint
    // PurchaseOrderVoucherBody already uses, which also returns
    // approval_status directly — no separate fetch needed for that anymore.
    purchaseOrderRecordnWithDetailsApi({ pur_o_id, from: "voucher" })
      .then((res) => {
        if (res?.data?.length) {
          setData(res.data[0]);
        }
      })
      .catch((err) => console.error("Fetch corporate voucher failed", err));
  }, [pur_o_id]);

  if (!data) return null;

  // Same real-enforcement pattern as PurchaseOrderVoucherBody: this
  // component renders in printMode for both the hidden react-to-print
  // layout (Print) and the /print/purchase-order/:id route the backend
  // Puppeteer service screenshots (Download) — blocking the render here
  // blocks both regardless of which record it fetches.
  if (printMode && data.approval_status === "pending") {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        <Title level={4}>Pending Approval</Title>
        <Text>This purchase order is pending approval and cannot be downloaded or printed yet.</Text>
      </div>
    );
  }

  return (
    <Card
      className="shadow-md rounded-xl mt-4"
      bordered={!printMode}
      styles={{
      body: { padding: printMode ? "0" : "16px"},
    }}     
    >
      <Title level={5}>Corporate Purchase Order Voucher</Title>
      <Text strong>Corporate Name: </Text> {data.corporate_name}
      <br />
      <Text strong>Voucher No: </Text> {data.pur_order_no}
      <br />
      <Text strong>Grand Total: </Text> {data.grand_total}
    </Card>
  );
};

export default PurchaseOrderCorporateVoucher;
